import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';


export class SOPostEntity {

  constructor(
    public name: string,
    public editPermissions: boolean,
    public project: SOGetProject,
    public organization: SOGetOrganization,
    public description: string = "",
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostEntity(
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'editPermissions' in params ? params.editPermissions : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
